import { useState, useEffect } from 'react';

export function useElapsed(clockIn, clockOut) {
    const [elapsed, setElapsed] = useState('');

    useEffect(() => {
        if (!clockIn || clockOut) return;
        const update = () => {
            const diff = Math.max(0, Math.floor((Date.now() - new Date(clockIn)) / 60000));
            const h = Math.floor(diff / 60);
            const m = diff % 60;
            setElapsed(diff === 0 ? '0m' : `${h}h ${m}m`);
        };
        update();
        const iv = setInterval(update, 60000);
        return () => clearInterval(iv);
    }, [clockIn, clockOut]);

    return elapsed;
}

export function useRemaining(smena, clockOut) {
    const [remaining, setRemaining] = useState('');

    useEffect(() => {
        if (!smena || clockOut) return;
        const datum = typeof smena.datum === 'string' ? smena.datum.slice(0, 10) : smena.datum;
        const konec = new Date(`${datum}T${(smena.cas_do || '00:00').slice(0, 5)}:00`);
        const update = () => {
            const diff = Math.max(0, Math.floor((konec - Date.now()) / 60000));
            const h = Math.floor(diff / 60);
            const m = diff % 60;
            setRemaining(diff === 0 ? '0m' : `${h}h ${m}m`);
        };
        update();
        const iv = setInterval(update, 60000);
        return () => clearInterval(iv);
    }, [smena, clockOut]);

    return remaining;
}

export function useRoundedClockIn(hasClockIn) {
    const [rounded, setRounded] = useState('');

    useEffect(() => {
        if (hasClockIn) return;
        const calc = () => {
            const now = new Date();
            const m = now.getMinutes();
            const s = now.getSeconds();
            let min = m + (s > 0 ? 1 : 0);
            if (min === 0) {
                setRounded(`${String(now.getHours()).padStart(2, '0')}:00`);
            } else if (min <= 30) {
                setRounded(`${String(now.getHours()).padStart(2, '0')}:30`);
            } else {
                const h = (now.getHours() + 1) % 24;
                setRounded(`${String(h).padStart(2, '0')}:00`);
            }
        };
        calc();
        const iv = setInterval(calc, 30000);
        return () => clearInterval(iv);
    }, [hasClockIn]);

    return rounded;
}
